import { TributeVideoExportStatus } from '@/enums';
import {
  CanceledStatusIcon,
  CompletedStatusIcon,
  FailedStatusIcon,
  FinalizingStatusIcon,
  InProgressStatusIcon,
  PendingStatusIcon,
  PreparingStatusIcon
} from '@/resources';

type StatusOverviewConfig = {
  statusKey: TributeVideoExportStatus;
  statusIcon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  statusLabelKey: string;
};

export const STATUS_OVERVIEW: StatusOverviewConfig[] = [
  {
    statusKey: TributeVideoExportStatus.Preparing,
    statusIcon: PreparingStatusIcon,
    statusLabelKey: 'preparing'
  },
  {
    statusKey: TributeVideoExportStatus.Pending,
    statusIcon: PendingStatusIcon,
    statusLabelKey: 'pending'
  },
  {
    statusKey: TributeVideoExportStatus.InProgress,
    statusIcon: InProgressStatusIcon,
    statusLabelKey: 'inProgress'
  },
  {
    statusKey: TributeVideoExportStatus.RenderingCompleted,
    statusIcon: FinalizingStatusIcon,
    statusLabelKey: 'finalizing'
  },
  {
    statusKey: TributeVideoExportStatus.Completed,
    statusIcon: CompletedStatusIcon,
    statusLabelKey: 'completedStatus'
  },
  {
    statusKey: TributeVideoExportStatus.Failed,
    statusIcon: FailedStatusIcon,
    statusLabelKey: 'failed'
  },
  {
    statusKey: TributeVideoExportStatus.Canceled,
    statusIcon: CanceledStatusIcon,
    statusLabelKey: 'canceled'
  }
];
